import { M_SIPARIS_DETAY } from './../../../../models/M_SIPARIS_DETAY';
import { Ortak } from './../../../../providers/ortak';
import { CarisecPage } from './../../../faturaislemleri/carisec/carisec';

import { ViewController } from 'ionic-angular/navigation/view-controller';
import { ModalController } from 'ionic-angular/components/modal/modal-controller';
import { ToastController } from 'ionic-angular/components/toast/toast-controller';
import { BllSiparisDetay } from './../../../../providers/bll/bll-siparis-detay';
import { BllOrtak } from './../../../../providers/bll/bll-ortak';
import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

import { Searchbar } from 'ionic-angular';


/**
 * Generated class for the SatispagePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-satispage',
  templateUrl: 'satispage.html',
})
export class SatispagePage {

  aranan = "";
  skip: number = 0;
  take: number = 50;
  urunListesi = [];
  
  KategoriListesi = [];
  urunname: any = {};
  masaObj: any = {}
  secilenSiparisID: number = -1;
  siparisIdListesi = [{ ID: -1, value: "Tümü" }];
  siparisTip = 1;
  toplam:number=0;
  toplamIskonto: number = 0;
  siparisBaslikDurumID = 1;
  genelToplam: number = 0;
  odenenToplam: number = 0;
  tempToplam: number = 0;
  miktar: number = 1;
  indirimliGenelToplam: number = 0;
  onaylanmamisindirimliGenelToplam: number = 0;
  islemyapan = this.ortak.storagePersonelGetir.Name;
  onaylaPasif: boolean = false;
  aktarilacakCariKart: any = {};
  CariObj: any = {};
  aktifSiparisVeDetaylari: any = { SIPARIS_DETAYLARI: [] };
  CariID: any = { CariID: 1, BelgeTuru: 1 };
  @ViewChild('searchBar') searchInput;
  constructor(public navCtrl: NavController,
    public modalCtrl: ModalController,
    public ortak: Ortak,
    public view: ViewController,
    public navParams: NavParams,
    public bllOrtak: BllOrtak,
    public toast: ToastController) {

  }

  ionViewDidLoad() {

    this.urunAra("", "");
    this.KategoriListesiGetir();
    this.siparisDetayListesi_Temp();
   

  }
  ionViewDidEnter() {

  }
  focusInput(input) {
    input.setFocus();
  }


  urunAra(e, otoEkle) {
    var miktar: number = 1;
    if (this.aranan.split("*").length > 1) {
      miktar = parseFloat(this.aranan.split("*")[0]);
      this.aranan = this.aranan.split("*")[1];
    }
    var barkod = this.aranan;
    var strmiktar = parseFloat(this.aranan.substring(7, 12));
    if (this.aranan.length == 13 && (this.aranan.substring(0, 2) == "27" || this.aranan.substring(0, 2) == "28")) {
      barkod = this.aranan.substring(0, 7);
      //alert(barcode);
      // var strmiktar = parseFloat(this.aranan.substring(7, 12));
      if (strmiktar != 0) {
        miktar = strmiktar / 1000;
      }
      else {
        alert("Hatalı Barkod");
      }
    }
    else if (this.aranan.length == 13 && (this.aranan.substring(0, 2) == "29")) {
      barkod = barkod.substring(0, 7);
      // var strmiktar = parseFloat(this.aranan.substring(7, 12));
      if (strmiktar != 0) {
        miktar = strmiktar;
      }
      else {
        alert("Hatalı Barkod");
      }

    }
    this.aranan = barkod;
    var formData = new FormData();
    formData.append("aranan", this.aranan);
    formData.append("skip", this.skip.toString());
    formData.append("take", this.take.toString());
    this.bllOrtak.islem(formData, "Stoklar", "", false).then(a => {
      var sonuc = <any>a;
      this.urunListesi = sonuc.SonucObject;
      if (this.urunListesi.length == 1) {
        if (otoEkle == true) {
          this.urunItemClick(this.urunListesi[0]);
        }

        this.aranan = "";
      }

    }).catch(x => {
  

    })
  }
  urunler(e) {

    if (e.keyCode == 13) {
      this.urunAra(-1, true);

    }
  }

  presentToast(mesaj) {
    let toast = this.toast.create({
      message: mesaj,
      duration: 1000,
      showCloseButton: true,
      // closeButtonText: "Tamam",
      position: 'top'
    });
    toast.present();

  }
  urunItemClick(stok) {
    if (this.miktar.toString() == "")
      this.miktar = 1;


    var bllSiparisDetay = new BllSiparisDetay();
    this.miktar = 1;
    bllSiparisDetay.satinAlmaDetayEkle_Temp(this.aktarilacakCariKart.LogicalRef, stok.ID, this.miktar, stok.StokAdi, 8, -999, stok.Price2, stok.Price1, 255, this.islemyapan).then(a => {
      //this.presentToast(stok.StokAdi);//toast konacak
      this.siparisDetayListesi_Temp();


    });
    this.onaylaPasif = false;

  }
  KategoriListesiGetir() {
    var formData = new FormData();
    formData.append("aranan", this.aranan);
    formData.append("skip", this.skip.toString());
    formData.append("take", this.take.toString());
    this.bllOrtak.islem(formData, "KategoriListesi", "", false).then(a => {
      var sonuc = <any>a;
      this.KategoriListesi = sonuc.SonucObject;


    })

  }
  siparisDetayListesi_Temp() {

    var bllSiparisDetay = new BllSiparisDetay();
    bllSiparisDetay.getAll({ siparisID: -999 }).then(a => {
      this.aktifSiparisVeDetaylari.SIPARIS_DETAYLARI = this.aktifSiparisVeDetaylari.SIPARIS_DETAYLARI.filter(a => a.SIPARIS_DURUM_ID != 255);
      this.aktifSiparisVeDetaylari.SIPARIS_DETAYLARI = this.aktifSiparisVeDetaylari.SIPARIS_DETAYLARI.concat(a);
      this.aktifSiparisVeDetaylari.SIPARIS_DETAYLARI = this.aktifSiparisVeDetaylari.SIPARIS_DETAYLARI.sort((c1, c2) => c1.SIPARIS_DURUM_ID < c2.SIPARIS_DURUM_ID);
      this.fiyatHesapla(this.aktifSiparisVeDetaylari.SIPARIS_DETAYLARI.filter(a => a.SIPARIS_DURUM_ID != 255), a);


    }).catch(x => {
      
    })
  }
  cacheTemizle() {
    var siparisID = -999;
    this.onaylaPasif = true;
    var bllSiparisDetay = new BllSiparisDetay();
    bllSiparisDetay.execRawQuery("DELETE FROM M_SIPARIS_DETAY WHERE siparisID = " + siparisID).then(b => {
      this.siparisDetayListesi_Temp();
      this.onaylaPasif = true;
    }).catch(x => {
     
    })
    this.aranan = "";
  }
  onayla() {
    this.onaylaPasif = true;
    var siparisID = -999;

    var bllSiparisDetay = new BllSiparisDetay();
    bllSiparisDetay.getAll().then(a => {
      var formData = new FormData();
      
      formData.append("siparis_detaylari_json", JSON.stringify(a));
      formData.append("siparis_detaylari2", JSON.stringify(this.CariID));
      
      formData.append("toplam", this.toplam.toString());
   

      this.bllOrtak.islem(formData, "PerakendeSatis", "", true).then(a => {
        var sonuc = <any>a;
       
        bllSiparisDetay.execRawQuery("DELETE FROM M_SIPARIS_DETAY WHERE siparisID = " + siparisID).then(b => {
          this.siparisDetayListesi_Temp();
        }).catch(x => {
      
        })
      }).catch(x => {
        this.onaylaPasif = false;

   
      })
    }).catch(x => {
      this.onaylaPasif = false;
      this.ortak.showErrorAlert();
    })
  }

  fiyatHesapla(onaylanmisSiparisDetaylari, onaylanmamisSiparisDetaylari) {
    this.genelToplam = 0;
    this.toplam = 0;
    this.odenenToplam = 0;
    this.onaylanmamisindirimliGenelToplam = 0;
    onaylanmisSiparisDetaylari.forEach(item => {
      var satirToplamTutar = item.BirimFiyat * item.Miktar;
      var satirrOdenenTutar = item.BirimFiyat * item.ODENEN_MIKTAR;
      var satirKalanTutar = satirToplamTutar - satirrOdenenTutar;
      this.genelToplam = this.genelToplam + satirKalanTutar;
      this.toplam = this.toplam + satirToplamTutar;
      this.odenenToplam = this.odenenToplam + satirrOdenenTutar;
      this.indirimliGenelToplam = this.genelToplam;
    });
    onaylanmamisSiparisDetaylari.forEach(item => {
      var satirToplamTutar = item.BirimFiyat * item.Miktar;
      var satirrOdenenTutar = item.BirimFiyat * item.ODENEN_MIKTAR;
      var satirKalanTutar = satirToplamTutar - satirrOdenenTutar;
      this.genelToplam = this.genelToplam + satirKalanTutar;
      this.toplam = this.toplam + satirToplamTutar;
      this.odenenToplam = this.odenenToplam + satirrOdenenTutar;
      this.onaylanmamisindirimliGenelToplam = this.genelToplam - this.indirimliGenelToplam;
    });

  }


  miktarArttir(detay) {
    if (detay.SIPARIS_DURUM_ID == 255)
      detay.Miktar = detay.Miktar + 1; this.miktarChange(detay)


  }

  miktarAzalt(detay) {
    if (detay.SIPARIS_DURUM_ID == 255) {
      if (detay.MIKTAR == 1) {
        this.siparisSil(detay);
      }
      else if (detay.MIKTAR >= 2) {
        detay.MIKTAR = detay.MIKTAR - 1;
        this.miktarChange(detay)
      }
      else if (detay.MIKTAR < 2 && detay.MIKTAR > 0) {
        detay.MIKTAR = detay.MIKTAR - 1;
        this.miktarChange(detay)
      }
    }
  }

  miktarDegistir(eq, detay) {
    if (eq.keyCode == 13) {
      this.miktarChange(detay);
    }
  }

  miktarChange(detay) {
    if (detay.SIPARIS_DURUM_ID == 255) {
      if (detay.MIKTAR != "") {
        if (detay.MIKTAR >= 1) {
          var bllSiparisDetay = new BllSiparisDetay();
          bllSiparisDetay.miktarGuncelle(detay).then(a => {
            this.siparisDetayListesi_Temp();
          }).catch(x => {
         
          })
        }
        else
          detay.MIKTAR = 1;
      }
    }

  }


  birimFiyatChange(e, detay) {
    if (e.keyCode == 13) {
      if (detay.BIRIM_FIYAT != "" && detay.BIRIM_FIYAT >= 0) {
        var bllSiparisDetay = new BllSiparisDetay();
        bllSiparisDetay.birimFiyatGuncelle(detay).then(a => {
          this.siparisDetayListesi_Temp();
        }).catch(x => {
        
        })
      }
    }
  }
  siparisYukelemeIslemleri() {


    // var aktifSiparislerKalkanMasa = <any[]>this.masaObj.siparislerVeDetaylari.filter(a => a.SIPARIS_DURUM_ID == 2);
    // if (aktifSiparislerKalkanMasa.length > 0)
    //   this.masaObj = aktifSiparislerKalkanMasa[0];
    this.masaObj.siparislerVeDetaylari = this.masaObj.siparislerVeDetaylari.filter(a => a.SIPARIS_BASLIK.SIPARIS_DURUM_ID == this.siparisBaslikDurumID);
    this.siparisIdListesi = [];
    if (this.masaObj.siparislerVeDetaylari.length > 1) {
      if (this.siparisTip == 1) {
        this.siparisIdListesi.push({ ID: -1, value: "Tümü" }); //*-*-*-*
        this.secilenSiparisID = -1;
        let toast = this.toast.create({
          message: "Bu masaya ait birden fazla sipariş listesi mevcut. Daha öncesinde masa aktarma işlemi yapılmış olabilir. İşlem yaparken sipariş seçiminize dikkat ediniz !",
          duration: 2000,
          showCloseButton: true,
          closeButtonText: "Tamam",
          position: 'middle',
        });
        toast.present();
      }
      if (this.siparisTip == 2) {

      }

      var tumSiparisDetaylari = [];
      this.masaObj.siparislerVeDetaylari.forEach(element => {
        var musteriBilgisi = "";
        if (this.siparisTip == 2) {
          musteriBilgisi = element.SIPARIS_BASLIK.CARI_UNVAN + " ";
        }
        else {

        }

        tumSiparisDetaylari = tumSiparisDetaylari.concat(element.SIPARIS_DETAYLARI);
        this.siparisIdListesi.push({ ID: element.SIPARIS_BASLIK.ID, value: musteriBilgisi + "Sipariş No: " + element.SIPARIS_BASLIK.ID });
      });

      var butunSiparisVeDetaylari = { SIPARIS_BASLIK: { ID: -1 }, SIPARIS_DETAYLARI: tumSiparisDetaylari };

      this.masaObj.siparislerVeDetaylari.push(butunSiparisVeDetaylari);
      // this.aktifSiparisVeDetaylari = butunSiparisVeDetaylari;

      this.siparisBaslikChange();



    }
    else {
      var musteriBilgisi = "";
      this.aktifSiparisVeDetaylari = this.masaObj.siparislerVeDetaylari[0];
      if (this.siparisTip == 2) {
        musteriBilgisi = this.aktifSiparisVeDetaylari.SIPARIS_BASLIK.CARI_UNVAN + " ";
      }
      else {
      }
      this.siparisDetayListesi_Temp();
    }

  }
  siparisBaslikChange() {
    this.aktifSiparisVeDetaylari = this.masaObj.siparislerVeDetaylari.filter(a => a.SIPARIS_BASLIK.ID == this.secilenSiparisID)[0];


  }

  siparisSil(detay) {
    if (detay.SIPARIS_DURUM_ID == 255) {
      var bllSiparisDetay = new BllSiparisDetay();
      bllSiparisDetay.delete({ ID: detay.ID }).then(a => {
        this.siparisDetayListesi_Temp();
      }).catch(x => {
        
      })
    }
  }



}



// WEBPACK FOOTER //
// ./src/pages/Muhasebe/Satis/satispage/satispage.ts